export const CurrencyCode = {
    Eur: 'EUR',
    Gbp: 'GBP',
    Usd: 'USD',
} as const;

export type CurrencyCode = (typeof CurrencyCode)[keyof typeof CurrencyCode];
